import React, {useEffect} from "react";
import {Grid, IconButton} from "@mui/material";
import {ArrowBack} from "@mui/icons-material";
import {RootGrid, HeaderTypography} from "./taxonomy";
import {PocAutoIgnoreProperties} from "../../../../settings/default_properties";
import SettingModifier from "../components/setting_modifier";
import {getAttributes as utilGetAttributes} from "../../../../../utils/utils";
import EnhancedErrorDialog from "../../../../../components/EnhancedErrorDialog";
import {pageContentGap} from "../../../../../theme";

interface AutoIgnoreProps {
    setTitle?: (title: string, flag: boolean) => void;
    isRetailer?: boolean;
    location: {
        key?: string;
    };
    history: {
        push: (path: string) => void;
        goBack: () => void;
    };
}

interface ErrorState {
    open: boolean;
    errorHeader: string;
    errorMessage: string;
}

const iconButtonSx = (theme: any) => ({
    backgroundColor: "white",
    border: "none",
    borderRadius: "6px",
    "& svg": { color: "rgba(0, 0, 0, 0.54)" }
});

export default function AutoIgnore(props: AutoIgnoreProps) {
    const {setTitle} = props;
    const [error, setError] = React.useState<ErrorState>({open: false, errorHeader: "", errorMessage: ""});
    const [attributes, setAttributes] = React.useState<any[]>([]);
    useEffect(() => {
        if(setTitle) {
            setTitle('POC Auto Ignore Settings', true);
        }
        const getAttributes = async () => {
            const attributes = await utilGetAttributes("", (props as any).isRetailer);
            if (attributes.errorMessage) {
                setError(attributes);
            } else {
                setAttributes(attributes);
            }
        }
        getAttributes();
        // eslint-disable-next-line
    }, []);
    return (
        <RootGrid container
              style={{gap: pageContentGap, padding: "24px 14px 24px 14px", position: "relative", width: "100%", overflow: "hidden"}}>
            <Grid container justifyContent={"space-between"} direction={"row"}>
                <Grid container justifyContent={"flex-start"} alignItems={"center"} style={{gap: pageContentGap, width: "100%"}}>
                    <IconButton
                        sx={iconButtonSx}
                        style={{height: "36px", width: "36px", position: 'relative', zIndex: 1}}
                        onClick={(e) => {
                            e.preventDefault();
                            if (props.location.key === undefined)
                                props.history.push("/productonboardingcenter/catalog");
                            else
                                props.history.goBack();
                        }}
                        size="large">
                        <ArrowBack style={{height: "18px", width: "18px"}}/>
                    </IconButton>
                    <HeaderTypography>
                        Auto Ignore Settings
                    </HeaderTypography>
                </Grid>
            </Grid>
            <PocAutoIgnoreProperties
                isMulti={true}
                options={attributes}
                template={(templateProps: any) => {
                    return <SettingModifier {...templateProps} />
                }}
            />
            <EnhancedErrorDialog open={error.open} onClose={() => setError({...error, open: false})}
                                 errorHeader={error.errorHeader} errorMessage={error.errorMessage}/>
        </RootGrid>
    );
}
